import * as React from "react";
import {ConfigProvider } from 'antd';
const { useState, useEffect, isValidElement } = React;
const DynamicComponent = ({ name, componentRef, props, isDev }) => {

  const [Component, setComponent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      if (isValidElement(<componentRef />)) {
        Object.defineProperty(componentRef, 'name', { value: name ? name : 'DynamicComponent' });
        setComponent(() => componentRef);
        setError(null);
      } else {
        setError("Not a valid component");
        setComponent(null);
      }

    } catch (err) {
      setError(err);
      setComponent(null);
    }
  }, [componentRef, isDev]);

  if (error) {
    return (
      <div style={{ color: 'red' }}>
        Error compiling component: {error.message}
      </div>
    );
  }

  if (!Component) {
    return (
      <div style={{ color: 'red' }}>
        {name} component not found.
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: 'rgb(79 70 229)',
          borderRadius: 5
        },
      }}
    >
      <Component {...props} />
    </ConfigProvider>
  );
};

export default DynamicComponent;